import React, {Component} from "react";
import styled from "styled-components";
import AnchorLink from "react-anchor-link-smooth-scroll";

import {
  lightest,
  Contain,
  primary,
  ContainWPadding,
  grayText,
  gray,
  lighter,
  light,
  mediaMaxPhone
} from "../Tools/Variables";
import {HeaderHeight} from "../Global/Header";

const Wrapper = styled.div `
  background: gray;
  margin-top: ${HeaderHeight};

  width: 100%;
  height: 0px;
  position: fixed;
  top: 0;
  z-index: 1;
  @media screen and (${mediaMaxPhone}){

    display:none;
  }
`;

const Line = styled.div `
  background: ${primary};
  height: 4px;
  width: 100%;
`;

const SubMenu = styled.ul `
  text-align: center;
  display: block;
  padding: 0;

  margin: 0 auto;
`;

const MenuItem = styled.li `
  text-transform: uppercase;
  font-weight: 300;
  color: ${gray};
  display: inline-block;
  margin: 0 10px;

  opacity: 1;
  :hover {
    opacity: 0.5;
  }
`;
const LocationWrapper = styled.div `
  position: fixed;
  right: 0;
  top: 30vh;
`;

const Circle = styled.div `
  transition: 0.5s;
  height: 5px;
  width: 5px;
  border-radius: 0px;
  background: ${light};
  margin: 20px;
  opacity: ${props => (props.active
  ? "0.9"
  : "0.2")};
`;

const SideTitle = styled.div `
  white-space: nowrap;
  transition: 0.8s ease;
  text-transform: uppercase;
  font-size: 11px;
  font-weight: 300;
  color: ${light};
  position: absolute;
  top: 0;
  line-height: 10px;
  transform: rotate(-90deg) translate(0px, 23px);
  transform-origin: 0% 50%;

  letter-spacing: 1.8px;
  visibility: ${props => (props.active
  ? "visible"
  : "hidden")};
  opacity: ${props => (props.active
  ? "1"
  : "0")};
  transform: ${props => props.active
  ? "rotate(-90deg) translate(0px, 23px)"
  : "rotate(-90deg) translate(0px, 40px)"};
`;

class StickyHeader extends Component {
  render() {
    return (
      <Wrapper>
        <ContainWPadding>{/*

          <Line/>
    */}</ContainWPadding>
        <LocationWrapper>
          <SideTitle active={this.props.activeLocation === 1}>
            Kontroll
          </SideTitle>
          <SideTitle active={this.props.activeLocation === 2}>
            Varför?
          </SideTitle>
          <SideTitle active={this.props.activeLocation === 3}>
            Hållbarhet
          </SideTitle>
          <SideTitle active={this.props.activeLocation === 4}>
            Prestera
          </SideTitle>
          <SideTitle active={this.props.activeLocation === 5}>
            Intresseanmälan
          </SideTitle>
          <SideTitle active={this.props.activeLocation === 6}>FAQ</SideTitle>
          <AnchorLink offset="100" href="#controllSection">
            <Circle active={this.props.activeLocation === 1}/>
          </AnchorLink>
          <AnchorLink offset="100" href="#whySection">
            <Circle active={this.props.activeLocation === 2}/>
          </AnchorLink>
          <AnchorLink offset="100" href="#susSection">
            <Circle active={this.props.activeLocation === 3}/>
          </AnchorLink>
          <AnchorLink offset="100" href="#activeSection">
            <Circle active={this.props.activeLocation === 4}/>
          </AnchorLink>
          <AnchorLink offset="100" href="#intrSection">
            <Circle active={this.props.activeLocation === 5}/>
          </AnchorLink>
          <AnchorLink offset="100" href="#faqSection">
            <Circle active={this.props.activeLocation === 6}/>
          </AnchorLink>
        </LocationWrapper>
        {/*

        <SubMenu>
          <MenuItem href='controllSection'>
            <AnchorLink href='#controllSection'>Fjärllkontroll</AnchorLink>

          </MenuItem>
          <MenuItem>
            Hållbarhet
          </MenuItem>
          <MenuItem>
            Exempel
          </MenuItem>

        </SubMenu>
        */}
      </Wrapper>
    );
  }
}

export default StickyHeader;



// WEBPACK FOOTER //
// ./src/Home/StickyHeader.js